<template>
  <div class="card" v-if="allOptions">
    <div class="fty"><div v-show="isActive == index">功能权限：</div></div>
    <!-- :indeterminate="isIndeterminate" -->
    <el-checkbox v-model="checkAll" @change="handleCheckAllChange">
    <span>{{allOptions.label}}</span></el-checkbox>
    <el-checkbox-group
      v-model="checkedAuth"
      class="tr"
      :class="{ flex: index <= 3 }"
      @change="checkedChange"
    >
      <el-checkbox v-for="auth in checkOptions" :label="auth.key" :key="auth.key">
        {{ auth.label }}
      </el-checkbox>
    </el-checkbox-group>
    <!-- 第二层 -->
    <div v-if="index > 3">
      <div class="td" v-for="item in checkOptions" :key="item.key">
        <el-checkbox-group v-model="checkedAuth" v-if="item.children" @change="checkedChange">
          <el-checkbox v-for="auth in item.children" :label="auth.key" :key="auth.key">
            {{ auth.label }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="el-checkbox" v-else></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: {
      type: Number
    },
    allOptions: {
      type: Object
    },
    // 选项
    checkOptions: {
      type: Array,
      required: true
    },
    // 默认选中项
    checked: {
      type: Array
    }
  },
  watch: {
    checked(val) {
      this.checkedAuth = [...new Set(val)]
      this.checkAll = val.length > 0
    }
  },
  data() {
    return {
      checkedAuth: [...new Set(this.checked)],
      // isIndeterminate: true,
      checkAll: false,
      checkedOptions: [],
      checkedValue: [],
      isActive: 0,
      disabled: true
    }
  },
  mounted() {
    this.checkOptions.forEach(v => {
      this.checkedOptions.push(v.key)
      if (v.children) {
        for (const item of v.children) {
          this.checkedOptions.push(item.key)
        }
      }
    })
  },
  methods: {
    handleCheckAllChange(val) {
      // this.checkAll = this.checkedAuth.length > 0
      this.checkedAuth = val ? this.checkedOptions : []
      // this.isIndeterminate = false
      this.$emit('get-checked', val ? this.checkedOptions : [], this.index)
      // val && (this.checkedAuth = this.checkedOptions)
    },
    checkedChange(value) {
      const checkedCount = value.length
      this.checkAll = value.length > 0
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedOptions.length
      this.checkedValue = value
      this.$emit('get-checked', value, this.index)
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  border: 1px solid #d8dce6;
  border-bottom: none;
  .fty{
    width: 140px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #d8dce6;
  }
  // &:last-child {
  //   border-bottom: 1px solid #d8dce6;
  // }
  .el-checkbox {
    padding: 0 30px;
    width: 140px;
    height: 40px;
    margin-right: 10px;
    line-height: 40px;
    // border-right: 1px solid #d8dce6;
    box-sizing: border-box;
  }
}
.tr {
  flex-direction: column;
  border-left: 1px solid #d8dce6;
  // border-right: 1px solid #d8dce6;
  &.flex {
    flex-direction: row;
    border-right: none;
  }
}

.el-checkbox-group {
  display: flex;
  line-height: 40px;
}
::v-deep .el-checkbox:last-of-type{
  margin-right: none;
}
</style>
